// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const flatMap = (array: any[]): any[] => {
  return array
    ? array.reduce((acc, curVal) => {
        return acc.concat(curVal);
      }, [])
    : [];
};
